export const env = {
  API_ZENDESK_WIDGET: process.env.NEXT_PUBLIC_API_ZENDESK_WIDGET,
  APPSFLYER_DEV_KEY: process.env.NEXT_PUBLIC_APPSFLYER_DEV_KEY,
  APPSTORE_ID: process.env.NEXT_PUBLIC_APPSTORE_ID,
  BEST_OF_BRITAIN: process.env.NEXT_PUBLIC_BEST_OF_BRITAIN === 'enabled',
  BUILD_ID: process.env.BUILD_ID,
  CMS_LANDING_URL: process.env.NEXT_PUBLIC_CMS_LANDING_URL,
  CMS_URL: process.env.NEXT_PUBLIC_CMS_URL,
  COUPLESIDE_URL: process.env.NEXT_PUBLIC_COUPLESIDE_URL,
  CROWDIN_IN_CONTEXT: process.env.NEXT_PUBLIC_CROWDIN_IN_CONTEXT === 'true',
  CUSTOMER_IO_API_KEY: process.env.CUSTOMER_IO_API_KEY,
  CUSTOMER_IO_SITE_ID: process.env.CUSTOMER_IO_SITE_ID,
  CUSTOMERIO_APP_API_KEY: process.env.CUSTOMERIO_APP_API_KEY,
  ENCRYPTION_SECRET: process.env.ENCRYPTION_SECRET,
  ENQUIRIES_USER_LIMIT: process.env.NEXT_PUBLIC_ENQUIRIES_USER_LIMIT,
  FIREBASE: {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  },
  IS_PRODUCTION_BUILD: process.env.NODE_ENV === 'production',
  IS_VISUAL_TEST: process.env.NEXT_PUBLIC_APP_MODE === 'visual',
  JWT_SECRET: process.env.JWT_SECRET,
  LIVE: process.env.NEXT_PUBLIC_DATABASE === 'production',
  MIXPANEL_TOKEN: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
  PLATFORM_VERSION: process.env.NEXT_PUBLIC_PLATFORM_VERSION,
  RECAPTCHA_PUBLIC_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_PUBLIC_KEY ?? '',
  RECAPTCHA_SECRET: process.env.RECAPTCHA_SECRET,
  SECRET_COOKIE_PASSWORD: process.env.SECRET_COOKIE_PASSWORD,
  SEGMENTID: process.env.NEXT_PUBLIC_SEGMENTID,
  STATIC: process.env.NEXT_PUBLIC_STATIC,
  STRIPE_API_KEY: process.env.NEXT_PUBLIC_STRIPE_API_KEY,
  TALKJS_APP_ID: process.env.NEXT_PUBLIC_TALKJS_APP_ID,
  WEBFLOW_BASE_URL: process.env.NEXT_PUBLIC_WEBFLOW_BASE_URL,
};
